import { render, staticRenderFns } from "./HeaderDesktopButton.vue?vue&type=template&id=5c55943c"
import script from "./HeaderDesktopButton.vue?vue&type=script&lang=js"
export * from "./HeaderDesktopButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports